import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { Option } from '@/common/types';
import { API_URL, IPlanYearPlanDto } from '@/dtos';
import { PlanByPlanYear } from '@/modules/HealthPlan/HealthPlan.types';

// import { useIsOrganizationType } from '@/modules/user/hooks';

export const getPlansList = (id?: string) => () =>
  api.get<IPlanYearPlanDto[]>(API_URL.PLAN_YEARS_PLANS_BY_ID(id || ''));

export const PLANS_BY_PLAN_YEAR_QUERY_KEY = 'getHealthTemplatesList';

export type ExpandedOption = Option & {
  id: string;
  name: string;
};

interface Params {
  id?: string;
}
export const usePlansByPlanYearQuery = (params: Params) => {
  const { isLoading, error, data, isSuccess, isError, refetch } = useQuery(
    [PLANS_BY_PLAN_YEAR_QUERY_KEY, params.id],
    getPlansList(params?.id),
    {
      enabled: !!params.id,
    }
  );

  const formatedPlans: PlanByPlanYear[] = useMemo(() => {
    const list = data?.data || [];

    return list.map(
      (item): PlanByPlanYear => ({
        id: `${item.id}`,
        name: item?.name || '',
        maxElectionAmount: item.max_election_amount || 0,
        minElectionAmount: item.min_election_amount || 0,
        canSetHealthPlanSpendLimits: item.can_set_health_plan_spend_limits ?? true,
      })
    );
  }, [data]);

  const formatedOptions = useMemo<ExpandedOption[]>(() => {
    const list = data?.data || [];

    return list.map(
      (item): ExpandedOption => ({
        key: `${item.id}`,
        id: `${item.id}`,
        name: item.name || '',
        value: item.name || '',
        title: item.name || '',
      })
    );
  }, [data]);

  return {
    data: formatedPlans,
    error,
    isError,
    isLoading,
    isSuccess,
    formatedOptions,
    refetch,
  };
};
export default usePlansByPlanYearQuery;
